define('webshopCategoriesDetailBodyUrlsV1View',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'webshopCategoriesDetailBodyUrlsV1DomainView',
  'template!webshopCategoriesDetailBodyUrlsV1View',
  'entities/webshop/categories',
  'entities/webshop/webshop'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  DomainView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    className: 'webshop-categories-detail-body-urlsv1-view',
    childView: DomainView,
    childViewContainer: '.domains-container',
    childViewOptions: function () {
      return {
        webshopConfig: this.webshopConfig,
        categoryCode: this.model.getCode()
      };
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
      this.webshopConfig = this.options.webshopConfig;
      this.fetchRequest = null;
    },

    serializeData: function () {
      var data = {};
      var url = Settings.configValue('webshop.url');
      data.adminUrl = url + '/admin/default/jqadm/get/catalog/' + this.model.getId();
      return data;
    },

    onShow: function () {
      this.fetch();
    },

    fetch: function () {
      this.collection.reset();

      var params = {
        code: this.model.getCode()
      };

      this.collection.reset();

      if (this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('webshop.category.urls', params),
        success: _.bind(function (items) {
          this.collection.add(items);
        }, this)
      });
    }
  });
});
